import moment from "moment";
import { ACTIVITY_TYPE } from "../../common/Constants";

export const TAB_CODE = {
  BELUM_CAIR: "BELUM_CAIR",
  BELUM_PEMENUHAN: "BELUM_PEMENUHAN",
  LENGKAP: "LENGKAP",
};

export const MANAGEMENT_CLAIM_TAB = [
  { label: "BELUM CAIR", value: TAB_CODE.BELUM_CAIR },
  { label: "BELUM PEMENUHAN", value: TAB_CODE.BELUM_PEMENUHAN },
  { label: "LENGKAP", value: TAB_CODE.LENGKAP },
];

export const INITIAL_DATE = moment().format("DD-MM-YYYY");

export const INITIAL_PAGINATION = {
  limit: 5,
  page: 1,
  totalData: 0,
};

export const INITIAL_DATA_CLAIM_PART = {
  kodePart: null,
  namaPart: null,
  kategori: null,
  qty: null,
  hetReal: null,
  het: null,
  ongkosKerja: null,
  isSaved: false,
};

export const TIPE_PENGAJUAN_CONSTANT = [
  { label: "C1", value: "C1" },
  { label: "C2", value: "C2" },
];

export const DDL_IS_NON_HOTLINE_FILTER = [
  { label: "YA", value: true },
  { label: "TIDAK", value: false },
];

export const CLAIM_CODE_GET_DATA_BBM = "PAYTYPE0003";

export const NOT_COMPLETE_TAB = [TAB_CODE.BELUM_PEMENUHAN, TAB_CODE.BELUM_CAIR];

export const SUCCESS_ALERT_MESSAGE = {
  [ACTIVITY_TYPE.CREATE]: "Data Berhasil Ditambah",
  [ACTIVITY_TYPE.UPDATE]: "Data Berhasil Disimpan",
  [ACTIVITY_TYPE.VIEW]: "Data Berhasil Diproses",
};

export const INITIAL_FILTER = {
  idClaim: null,
  startTanggalClaim: null,
  endTanggalClaim: null,
  nomorClaim: null,
  tipeClaim: null,
  nomorBbmPencarian: null,
  nonHotline: null,
  idHotline: null,
  nomorPembelian: null,
  namaPelapor: null,
  namaPemilik: null,
  startTanggalLengkap: null,
  endTanggalLengkap: null,
  startTahunProduksiUnit: null,
  endTahunProduksiUnit: null,
  nomorRangka: null,
  nomorMesin: null,
  kodeVarian: null,
  kodeWarna: null,
  nik: null,
  alamat: null,
  provinsi: null,
  kabkot: null,
  kecamatan: null,
  kelurahan: null,
  kodePos: null,
  memberId: null,
  nomorHp1: null,
  nomorHp2: null,
  kodePart: null,
};
